import { useState, useEffect } from "react";
import PageWrapper from '../layouts/Index';
import PageTitle from './PageTitle';
import Alerts from "./Alerts";
import { useNavigate } from "react-router-dom";
import {
  addUpdateKyc,
  getTermsAndConditions,
  updateCustomerOnboardingStat,
  uploadUserFile,
} from "../services/PrequalificationService";
import { useDispatch, useSelector } from "react-redux";
import useCustomAlert from "./Alert2";
import useLoader from "../customHooks/useLoader";
import { SpinnerIcon } from "../utils/Loader";
import TandCModal from "../modals/TandCModal";
import { updatePrecustomer } from "../redux/features/precustomers/PrecustomerSlice";

const AODFTandC = () => {
   const [btnLabel, setBtnLabel] = useState("Accept");
   const navigate = useNavigate();
     const dispatch = useDispatch();
   const storePrecustomer = useSelector((state) => state?.precustomer?.precustomerData);
   const customAlert = useCustomAlert();
   const [loader, showLoader] = useLoader(SpinnerIcon);
   const [msg, setMsg] = useState("");
   const [msgType, setMsgType] = useState("");
   const [apiTC, setApiTc] = useState("");
   const [loading, setLoading] = useState(false);
   const [html, setHTML] = useState("");
   console.log(apiTC);

   // To handle the submission of handleSubmitSignature
   const handleSubmitSignature = async (signature) => {
      showLoader(true);
      setBtnLabel("Submitting...");

      // Send base64 string to api to get url
      const filePayload = {
         fileName: `customer-base64Str-${storePrecustomer.precustomer.precustomerId}`,
         base64String: signature,
      };
      const res = await uploadUserFile(filePayload);

      // If file upload successfull
      if (res.status === true) {
         // Send the payload now to the second api
         const tandCpayload = {
         preCustomerId: storePrecustomer?.precustomer?.precustomerId,
         type: "kyc",
         inputName: "esign",
         inputValue: res?.data,
         inputType: "kyc",
         };

         // Hit the api to update the customer's kyc with the returned url
         const res2 = await addUpdateKyc(tandCpayload);

         // setBtnLabel("Adding to kyc...");

         if (res2.status === true || res2.status === 200) {

            // Alert
            customAlert.showToast(
               "success",
               "Customer's T&C signature successfully submitted..!"
            );

            // Stop loader
            showLoader(false);
            setBtnLabel("Accept");

            setMsg("Customer's T&C signature successfully submitted..!");
            setMsgType("success");
            // Make api call to update the onboarding status
               await updateCustomerOnboardingStat(
                  storePrecustomer?.precustomer?.msisdn,
                  "RELEASE_DEVICE"
               );
         
               if (
                  dispatch(
                  updatePrecustomer({
                     ...storePrecustomer,
                     imei: res2?.data?.data?.imei || res2?.data?.imei,
                     onboarding_status: "deviceRelease",
                  })
                  )
               ) {
                  return navigate("/deviceRelease");
               }

         }else{
         customAlert.showToast(
            "error",
            `${res2?.message}` || "Failed to update kyc..!"
         )
         }
      } else {
         showLoader(false);
         setBtnLabel("Accept");
         // Trigger alert
         customAlert.showToast(
         "error",
         `${res?.message}` || "Submission of base64 string failed...!!!"
         );
         setMsg("Operation failed...!!!");
         setMsgType("danger");
      }
   };

   // Get terms and conditions from api immediately component mounts
   useEffect(() => {
      async function fetchData(payload, setState, setLoading) {
         // Set loading state
         setLoading(true);

         // Fetch customer details
         const res = await getTermsAndConditions(payload);

         if (res?.status === true) {
         // Set the state
         setState(res?.data);
         setLoading(false);
         setHTML(res?.data);
         } else {
         setLoading(false);
         customAlert?.showToast("error", `${res?.message}` || "Failed to terms and conditions..!");

         setMsg("Failed to terms and conditions..!");
         setMsgType("danger");
         }
      }

      // Get customertype and partnerid from local storage
      const partnerId = localStorage.getItem("allAboard-partnerid") !== "undefined" && JSON.parse(localStorage.getItem("allAboard-partnerid"));

      const tandCPayload = {
         partnerid: String(partnerId),
         preCustomerId: storePrecustomer?.precustomer?.precustomerId,
      };

      // Invoke function now
      fetchData(tandCPayload, setApiTc, setLoading);

   }, []);

  return (
     <PageWrapper>
         <PageTitle title="Prequal Terms And Conditions"/>
         <div className="row">
            <div className="col-md-12">
            <div className="card">
               {/* Alert - starts  */}
               {msg && (
                  <Alerts
                  alertType={msgType}
                  title={
                     msgType === "success"
                        ? "Successful...!!!"
                        : "Operation failed...!"
                  }
                  message={msg}
                  />
               )}

               {/* Display html here  */}
               {loading ? (
                  <div className="term_conditions_box_fetching">
                  Fetching terms and conditions...
                  </div>
               ) : (
                  <div className="term_conditions_box">
                  <div
                     className="card-body"
                     dangerouslySetInnerHTML={{ __html: html }}
                  />
                  </div>
               )}
            </div>
            </div>
            <div className="col-md-12">
            <div className="card">
               <div className="card-body text-center">
                  {/* Signature form  */}
                  <h5 className="text-left">
                  <b>Kindly sign in the box below!</b>
                  </h5>
                  <div className="row">
                  <div className="col-sm-12 col-md-6 col-lg-5">
                     <TandCModal
                        handleSubmitSignature={handleSubmitSignature}
                        loader={loader}
                        btnLabel={btnLabel}
                     />
                  </div>
                  </div>
               </div>
            </div>
            </div>
         </div>
     </PageWrapper>
  )
}

export default AODFTandC
